<template>
    <div>
        <AddressList :list="addressList" v-model="chosenAddressId" @add="showEdit=true" @edit="onEdit" @select="select"></AddressList>
        <Popup v-model="showEdit" position="bottom" :style="{height:'100%'}">
            <Icon name="close" size="24" style="position:fixed;z-index:2003;right:.2rem;top:.2rem;"
                  @click="showEdit=false"/>
            <AddressEdit show-set-default show-area :area-list="areaList" @save="onSave" :show-delete='addressInfo.id!==undefined'
                         @delete="onDelete" :address-info="addressInfo" ></AddressEdit>

        </Popup>
    </div>
</template>
<script>
    import AreaList from 'libs/area'
    import {AddressList, Popup, AddressEdit, Area, Icon} from 'vant';

    export default {
        name: "addressList",
        components: {
            AddressList,
            Popup,
            AddressEdit,
            Area,
            Icon
        },
        data() {
            return {
                showEdit: false,
                chosenAddressId: "",
                addressList: [],
                areaList: AreaList,
                addressInfo: {}
            }
        },
        watch:{
            showEdit(e){
                if(!e){
                    this.addressInfo = {}
                }
            }
        },
        methods: {
            select(e){
                this.$storage.get('orderid').then((res)=>{
                    if(res){
                        this.$router.replace({name:'orderConfirm',params:{'orderid':res,'uaid':e.id}})
                    }else{
                        this.$toast.fail("系统繁忙,请重新进入")
                    }
                })

            },
            onSave(e) {
                let {name, tel, addressDetail, county, province, city, isDefault,id} = e
                let params = {name, province, city}
                Object.assign(
                    params,
                    {
                        mobile: tel, district: county, isdefault: isDefault ? 1 : 2, address: addressDetail,uaid:id
                    }
                );
                this.$api.address.editAddress(params).then((res) => {
                    if (res.status * 1 === 200) {
                        this.$toast.success("操作成功")
                    }
                    this.showEdit = false;
                    this.getAddressList()
                })

            },
            onDelete(e) {
                this.$api.address.delAddress({uaid:e.id}).then((res)=>{
                    if (res.status * 1 === 200) {
                        this.$toast.success("操作成功")
                    }
                    this.showEdit = false;
                    this.getAddressList()

                })
            },
            onEdit(e) {
                this.$toast.loading({duration:0})
                let provinceCode = ''
                for (var i in AreaList.province_list) {
                    if (AreaList.province_list[i] == e.province) {
                        provinceCode = i;
                        break;
                    }
                }
                provinceCode = provinceCode.substring(0, 2)
                let areaCode    =   '';
                for (var i in AreaList.county_list) {
                   if( i.substring(0,2) ==  provinceCode && AreaList.county_list[i]==e.district){
                       areaCode =   i;
                       break;
                   }

                }
                Object.assign(e, {areaCode,addressDetail: e.address, county: e.district, isDefault: e.isdefault == 1})
                this.addressInfo = e;
                setTimeout(()=>{
                    this.showEdit = true;
                    this.$toast.clear()
                },1e2)
            },
            getAddressList() {
                this.$api.address.getAddressList().then((res) => {
                    if (res.status * 1 === 200) {
                        this.addressList = res.data.list
                    }
                })
            }

        },

        mounted() {
            this.$nextTick(() => {
                if (this.$route.params.selectid)
                    this.chosenAddressId = this.$route.params.selectid
                this.getAddressList()
            })
        }
    }
</script>
